import { z } from "zod";
import { HttpMethodEnum, Route } from "../../../../utils/route";

// TODO: response should correspond to service resource
const responseType = z.any();

export default {
  method: HttpMethodEnum.GET,
  responseZodSchema: responseType,
} satisfies Route;
